import { render } from "./EditMruDetails.vue?vue&type=template&id=556fcbe6&scoped=true"
import script from "./EditMruDetails.vue?vue&type=script&lang=js"
export * from "./EditMruDetails.vue?vue&type=script&lang=js"

import "./EditMruDetails.vue?vue&type=style&index=0&id=556fcbe6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556fcbe6"]])

export default __exports__